import { LoadingStates } from '@pb/utils'

export default {
  status: LoadingStates.NotLoaded,
}
